import {generatePath} from '@legit-health/ui';
import {UserId} from '@legit-health/ui';
import {NOTIFICATIONS_LIST} from '@/shared/const/backend';
import useApiQuery, {UseApiQueryOptions} from '@/shared/hooks/useApiQuery';
import Notification from '@/shared/interfaces/Notification';
import PaginatedResults from '@/shared/interfaces/PaginatedResults';
import {NotificationStatus} from '@/shared/views/notification/const/notifications';

type UseNotificationsListOptions = {
  userId: UserId;
  searchParams: {
    page: number | string;
    status?: NotificationStatus;
  };
  queryOptions?: Omit<
    UseApiQueryOptions<PaginatedResults<Notification>>['queryOptions'],
    'queryKey'
  >;
};

export default function useNotificationsList({
  userId,
  searchParams,
  queryOptions
}: UseNotificationsListOptions) {
  const path = generatePath(NOTIFICATIONS_LIST, {userId}, searchParams);
  return useApiQuery<PaginatedResults<Notification>>({
    queryOptions: {
      queryKey: [NOTIFICATIONS_LIST, searchParams],
      ...queryOptions
    },
    requestArguments: {method: 'GET', path}
  });
}
